import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './style.scss';

const VIEW_AS_BUYER_QUERY = 'view_as_buyer',
    VIEW_AS_SELLER_QUERY = 'view_as_seller';

/**
 * @class
 * @name Buttons
 * @extends Component
 * @param {Object} user - all the user data
 * @param {Boolean} isMobileResponsive - mobile responsive or not
 * @param {Boolean} allowEditing - whether the user can edit
 * @param {Boolean} viewingAsBuyer - whether the seller is viewing their page as a buyer
 * @param {Boolean} isLoggedIn - whether the user is currently logged in
 * @param {Boolean} showCustomOrder - whether we should show the custom order button (if applicable)
 * Container for rendering markup of the contact/custom order buttons
 */

class Buttons extends Component {

    constructor(props) {
        super(props);
        this.onContactClick = this.onContactClick.bind(this);
        this.onViewAsClick = this.onViewAsClick.bind(this);
    }

    onContactClick() {
        // NOTE: MixpanelWrapper is instantiated in v2
        if (typeof MixpanelWrapper !== 'undefined') {
            MixpanelWrapper.bindLink(this.contactBtn, MixpanelWrapper.Events.ConversationEvents.CLICKED_CONTACT_ME);
        }
    }

    onViewAsClick(e) {
        e.preventDefault();
        const { viewingAsBuyer } = this.props;
        const queryType = viewingAsBuyer ? VIEW_AS_BUYER_QUERY : VIEW_AS_SELLER_QUERY,
            cleanLocation = window.location.href.split(/[?#]/)[0];
        window.location.href = `${cleanLocation}?${queryType}=true`;
    }

    render() {

        const {
            user,
            isMobileResponsive,
            allowEditing,
            viewingAsBuyer,
            isLoggedIn,
            showCustomOrder,
            inWhitingContactButton
        } = this.props;

        let contactCls,
            orderCls,
            showContact = user.has_live_gigs && (!user.is_on_vacation || (user.is_on_vacation && user.allow_contact)),
            showCustomOrderValid = showCustomOrder && user.is_seller && user.custom_orders_allowed && !allowEditing;

        // if user is viewing their own page in the seller view,
        // we don't show the "contact me"-button

        if (allowEditing && !viewingAsBuyer) {
            showContact = false;
        }

        const contactLink        = user.contact_path || `/conversations/${user.username}`,
            orderLink            = !isMobileResponsive ? '#!' : `/custom_orders/request/${user.username}/new`,
            showViewAs           = !isMobileResponsive && (allowEditing || viewingAsBuyer),
            viewAsString         = i18n.t(`seller_card.view_as_${viewingAsBuyer ? 'seller' : 'buyer'}`);

        if (user.is_spotlight) {
            showContact = false;
            showCustomOrderValid = false;
        }

        // if no buttons are shown, don't return the wrapper
        if (!showContact && !showCustomOrderValid && !showViewAs) {
            return null;
        }

        contactCls = classnames('btn-lrg-standard btn-contact-me', {
            'btn-white': inWhitingContactButton
        });

        orderCls = 'btn-lrg-standard btn-white btn-custom-order';

        if (!isMobileResponsive) {
            // TODO: "js-contact-me" is referenced in v2 (inside "popup-first-message.js"), needs to be updated
            // NOTE: "js-open-popup-login", "js-open-popup-join", "js-request-custom-order-button" are all bound to v2 JS functions

            contactCls = classnames(contactCls, 'js-contact-me', {
                'js-open-popup-login': !isLoggedIn
            });
            orderCls = classnames(orderCls, {
                'js-request-custom-order-button': isLoggedIn,
                'js-open-popup-join': !isLoggedIn
            });
        }

        return (
            <div className="buttons-wrapper">

                {showContact &&
                    <a href={contactLink} className={contactCls} onClick={this.onContactClick} ref={(ele) => { this.contactBtn = ele; }} rel="nofollow" data-user-id={user.username} data-redirect-url={contactLink}>{i18n.t('seller_card.contact_me')}</a>
                }

                {showCustomOrderValid &&
                    <a href={orderLink} className={orderCls}>{i18n.t('seller_card.custom_order')}</a>
                }

                {showViewAs &&
                    <a href="#!" className="btn-lrg-standard btn-white btn-view-as" onClick={this.onViewAsClick}>{viewAsString}</a>
                }

                <div id="react-first-message-popup"/>

            </div>
        );
    }
}

Buttons.propTypes = {
    user: PropTypes.object.isRequired,
    isMobileResponsive: PropTypes.bool.isRequired,
    allowEditing: PropTypes.bool.isRequired,
    viewingAsBuyer: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    showCustomOrder: PropTypes.bool.isRequired
};

export default Buttons;



// WEBPACK FOOTER //
// ./src/components/buttons/index.js